//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'mint-ui'
import { mapState } from 'vuex'
import moment from 'moment'
const config = window.config
export default {
  name: 'home-page',
  data() {
    return {
      mobile: '',
      smsCode: '',
    }
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted: function () {
    console.log(this.$route)
  },
  methods: {
    getDate (createdAt) {
      return moment(createdAt).format('YYYY-MM-DD')
    },
    dataDesensitization (num) {
      if (!num) return ''
      var len = num.length
      if(len && len > 4) {
        return num.substring(0, 3) + '****' + num.substring(len - 4, len)
      }
    }
  }
}
